import {Component, inject, Input, OnChanges, signal} from '@angular/core';
import {Client} from '../../../../api/client';

@Component({
  selector: 'app-rating',
  imports: [],
  templateUrl: './rating.component.html',
  standalone: true,
  styleUrl: './rating.component.scss'
})
export class RatingComponent implements OnChanges {
  @Input() productId!: string;
  private client = inject(Client);

  public rating = signal<number>(0);
  public userRating = signal<number | null>(null);
  public hoveredStar = signal<number | null>(null);
  public starsArray = Array(5).fill(0).map((_, i) => i + 1);

  ngOnChanges() {
    if (this.productId) {
      this.getProductRating();
    }
  }

  getProductRating() {
    this.client.reviews_Get(this.productId).subscribe({
      next: value => {
        this.rating.set(value);
        this.userRating.set(null);
      }
    });
  }

  setProductRating(star: number) {
    this.userRating.set(star);
    this.client.reviews_Create(this.productId, star).subscribe();
  }

  onMouseEnter(star: number) {
    this.hoveredStar.set(star);
  }

  onMouseLeave() {
    this.hoveredStar.set(null);
  }

  getFilledStars(): number {
    if (this.hoveredStar() !== null) {
      return this.hoveredStar()!;
    }
    if (this.userRating() !== null) {
      return this.userRating()!;
    }
    return Math.round(this.rating());
  }
}
